import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailMask',
  standalone: true,
})
export class EmailMaskPipe implements PipeTransform {
  transform(email?: string | null): string {
    if (!email) return '-';
    const [localPart, domainPart] = email.split('@');
    const maskedLocalPart = localPart[0] + '*****';
    const maskedDomainPart =
      '*****' + domainPart.slice(domainPart.indexOf('.'));
    return `${maskedLocalPart}@${maskedDomainPart}`;
  }
}
